interface ButtonStyleConfig {
	base?: string;
	default: string;
	disabled: string;
	inverted?: string;
}

const DEFAULT_DISABLED_STYLES =
	' bg-secondary-100 border border-secondary-100 text-secondary-400 cursor-not-allowed';

export const BUTTON_STYLE_CONFIG: Record<string, ButtonStyleConfig> = {
	primary: {
		default:
			' bg-primary-700 border border-primary-700 text-white hover:bg-primary-900 hover:border-primary-900' +
			' dark:bg-primary-600 dark:border-primary-600 dark:text-secondary-800' +
			' dark:hover:bg-primary-800 dark:hover:border-primary-800',
		disabled: DEFAULT_DISABLED_STYLES,
		inverted:
			' bg-white border border-white text-secondary-800  hover:bg-primary-200 hover:border-primary-200',
	},
	secondary: {
		default:
			' border border-primary-900 text-primary-900 hover:bg-primary-900 hover:border-primary-900 hover:text-white dark:hover:text-secondary-900',
		disabled: DEFAULT_DISABLED_STYLES,
		inverted:
			' border border-white text-white hover:bg-primary-200 hover:border-primary-200 hover:text-secondary-800',
	},
	blue: {
		default:
			' bg-[var(--color-plan-primary-700)] border border-[var(--color-plan-primary-700)] text-white dark:text-secondary-800 hover:bg-[var(--color-plan-primary-900)] hover:border-[var(--color-plan-primary-900)] dark:hover:text-secondary-900',
		disabled: DEFAULT_DISABLED_STYLES,
		inverted:
			' bg-transparent border border-[var(--color-plan-primary-700)] text-[var(--color-plan-primary-700)] hover:bg-[var(--color-plan-primary-900)] hover:border-[var(--color-plan-primary-900)] hover:text-white dark:hover:text-secondary-900',
	},
	red: {
		default:
			' bg-red-800 border border-red-800 text-white dark:text-secondary-800 hover:bg-red-900 hover:border-red-900',
		disabled: DEFAULT_DISABLED_STYLES,
	},
	dark: {
		default:
			' bg-secondary-800 border border-secondary-800 text-white hover:bg-secondary-900 hover:border-secondary-900',
		disabled: DEFAULT_DISABLED_STYLES,
	},
	link: {
		base: ' border-0 px-4 relative text-left',
		default: ' bg-transparent text-primary-900',
		disabled: ' text-secondary-400 cursor-not-allowed',
		inverted: ' bg-secondary-900 text-primary-300',
	},
	'link-dark': {
		base: ' border-0 px-4 relative text-left',
		default:
			' bg-transparent text-secondary-800 hover:text-secondary-900 dark:hover:text-primary-700',
		disabled: ' text-secondary-400 cursor-not-allowed',
	},
	'link-error': {
		base: ' px-4 relative text-left',
		default:
			' bg-transparent border border-error hover:bg-error text-error hover:text-white dark:hover:text-secondary-900',
		disabled: ' border-0 bg-secondary-100 text-secondary-400 cursor-not-allowed',
	},
	'blue-secondary': {
		default:
			' border border-[var(--color-plan-primary-700)] text-[var(--color-plan-primary-700)] hover:bg-[var(--color-plan-primary-900)] hover:border-[var(--color-plan-primary-900)] hover:text-white dark:hover:text-secondary-900',
		disabled: ' bg-secondary-100 border border-secondary-100 text-secondary-400 cursor-not-allowed',
	},
};
